import { render, staticRenderFns } from "./clazz-card-list.vue?vue&type=template&id=91d3c252&scoped=true&"
import script from "./clazz-card-list.vue?vue&type=script&lang=js&"
export * from "./clazz-card-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d3c252",
  null
  
)

export default component.exports